var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitterVaccination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_vaccination") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_vaccination"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.74,
    y: 300.78,
    width: 296.5,
    height: 296.5,
    transform: "translate(598.02 300.03) rotate(90)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,536.47,37,407.14a4.77,4.77,0,0,1,0-6.74l64.51-64.51a4.77,4.77,0,0,1,6.74,0L237.51,465.26Z",
    fill: "#28d6e9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.38,
    y: 497.16,
    width: 140.77,
    height: 24.9,
    rx: 4.79,
    transform: "translate(-298.61 298.3) rotate(-45)",
    fill: "#28d6e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.14,375.2,4.41,317.47a8.38,8.38,0,0,1,0-11.85l.34-.34a8.38,8.38,0,0,1,11.85,0L74.33,363Z",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.08,
    y: 512.95,
    width: 68.55,
    height: 40.22,
    transform: "translate(-308.58 321.14) rotate(-45)",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.77,
    y: 545.19,
    width: 108.94,
    height: 17.24,
    rx: 4.79,
    transform: "translate(-317.43 341.27) rotate(-45)",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mitat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.25,405l-28.86,28.86c-1.64,1.64-5.62.31-8.89-3l-.34-.34c-3.27-3.27-4.6-7.25-3-8.88l28.86-28.87Z",
    fill: "#2c3560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,369.1,112.5,398c-1.64,1.63-5.62.3-8.89-3l-.34-.34c-3.27-3.27-4.59-7.25-3-8.88l28.86-28.87Z",
    fill: "#2c3560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.14,440.88l-28.87,28.86c-1.63,1.64-5.61.31-8.88-3l-.34-.34c-3.27-3.27-4.6-7.25-3-8.89L201,428.69Z",
    fill: "#2c3560"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.79,564.42,156,553.59a4.77,4.77,0,0,1,0-6.74l10.38-10.38L37,407.14a4.77,4.77,0,0,1,0-6.74l25.21-25.2L4.41,317.47a8.35,8.35,0,0,1,0-11.8l.17-.17,254.6,254.6-34.68,34.68a4.77,4.77,0,0,1-6.74,0l-5.41-5.42a4.76,4.76,0,0,1,0-6.74l11.23-11.23-28.44-28.44-21.53,21.53A4.77,4.77,0,0,1,166.79,564.42Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.61,
    y: 150.38,
    width: 296.5,
    height: 296.5,
    transform: "translate(594.5 2.77) rotate(90)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.17,386.08,183.83,256.75a4.77,4.77,0,0,1,0-6.74l64.51-64.51a4.77,4.77,0,0,1,6.74,0L384.38,314.86Z",
    fill: "#28d6e9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.25,
    y: 346.77,
    width: 140.77,
    height: 24.9,
    rx: 4.79,
    transform: "translate(-149.25 358.1) rotate(-45)",
    fill: "#28d6e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,224.8l-57.73-57.72a8.38,8.38,0,0,1,0-11.85l.34-.34a8.38,8.38,0,0,1,11.85,0l57.73,57.73Z",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.95,
    y: 362.56,
    width: 68.55,
    height: 40.22,
    transform: "translate(-159.22 380.94) rotate(-45)",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.64,
    y: 394.8,
    width: 108.94,
    height: 17.24,
    rx: 4.79,
    transform: "translate(-168.07 401.08) rotate(-45)",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mitat-2",
    "data-name": "mitat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.12,254.6l-28.86,28.86c-1.64,1.64-5.62.31-8.89-3l-.34-.34c-3.27-3.27-4.6-7.25-3-8.89l28.86-28.86Z",
    fill: "#2c3560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,218.71l-28.86,28.86c-1.64,1.64-5.62.31-8.89-3l-.34-.34c-3.27-3.27-4.59-7.25-3-8.89L276,206.52Z",
    fill: "#2c3560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,290.49l-28.86,28.86c-1.64,1.63-5.62.31-8.89-3l-.34-.34c-3.27-3.27-4.6-7.25-3-8.89l28.86-28.86Z",
    fill: "#2c3560"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,414l-10.84-10.84a4.78,4.78,0,0,1,0-6.74l10.38-10.37L183.83,256.75a4.77,4.77,0,0,1,0-6.74L209,224.8l-57.73-57.72a8.35,8.35,0,0,1-.05-11.8l.17-.17L406,409.71l-34.68,34.68a4.77,4.77,0,0,1-6.74,0l-5.41-5.42a4.76,4.76,0,0,1,0-6.74L370.37,421l-28.44-28.44L320.4,414.06A4.77,4.77,0,0,1,313.66,414Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.24,
    y: 1.82,
    width: 296.5,
    height: 296.5,
    transform: "translate(601.57 -301.42) rotate(90)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.8,237.52,339.47,108.19a4.76,4.76,0,0,1,0-6.74l64.5-64.51a4.77,4.77,0,0,1,6.74,0L540,166.3Z",
    fill: "#28d6e9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.89,
    y: 198.2,
    width: 140.77,
    height: 24.9,
    rx: 4.79,
    transform: "translate(1.38 424.64) rotate(-45)",
    fill: "#28d6e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.64,76.24,306.91,18.52a8.38,8.38,0,0,1,0-11.85l.34-.34a8.38,8.38,0,0,1,11.85,0l57.73,57.72Z",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.59,
    y: 214,
    width: 68.55,
    height: 40.22,
    transform: "translate(-8.59 447.48) rotate(-45)",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.27,
    y: 246.24,
    width: 108.94,
    height: 17.24,
    rx: 4.79,
    transform: "translate(-17.44 467.61) rotate(-45)",
    fill: "#a00ce8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mitat-3",
    "data-name": "mitat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.75,106,450.89,134.9c-1.64,1.63-5.62.31-8.89-3l-.34-.34c-3.27-3.27-4.59-7.25-3-8.89l28.86-28.86Z",
    fill: "#2c3560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.86,70.15,415,99c-1.63,1.64-5.62.31-8.89-3l-.33-.34c-3.28-3.27-4.6-7.25-3-8.89L431.68,58Z",
    fill: "#2c3560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.64,141.92l-28.86,28.87c-1.64,1.63-5.62.3-8.89-3l-.34-.33c-3.27-3.28-4.6-7.26-3-8.89l28.86-28.86Z",
    fill: "#2c3560"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M469.29,265.47l-10.83-10.84a4.76,4.76,0,0,1,0-6.74l10.37-10.37L339.47,108.19a4.76,4.76,0,0,1,0-6.74l25.2-25.21L306.92,18.52a8.35,8.35,0,0,1-.06-11.8l.17-.17,254.6,254.6L527,295.83a4.78,4.78,0,0,1-6.75,0l-5.41-5.42a4.77,4.77,0,0,1,0-6.74L526,272.41,497.56,244,476,265.5A4.78,4.78,0,0,1,469.29,265.47Z",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterVaccination);
export default __webpack_public_path__ + "static/media/litter_vaccination.64b9441366c247374232e981fd65a402.svg";
export { ForwardRef as ReactComponent };